import { render, staticRenderFns } from "./UsuariosPropuesta.vue?vue&type=template&id=10764cc1&"
import script from "./UsuariosPropuesta.vue?vue&type=script&lang=js&"
export * from "./UsuariosPropuesta.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosPropuesta.vue?vue&type=style&index=0&id=10764cc1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports